import React from "react";
import { motion } from "framer-motion";

interface SectionHeadingProps {
    title: string;
    subtitle: string;
    description: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
    title,
    subtitle,
    description,
}) => {
    return (
        <header className="flex gap-5 max-md:flex-col">
            <div className="w-6/12 max-md:ml-0 max-md:w-full" >
                <div className="flex flex-col grow text-4xl font-bold text-white max-md:mt-10 max-md:max-w-full">
                    <h1 className="leading-[50px] max-md:max-w-full">{title}</h1>
                    <div className="relative inline-block mt-2.5">
                        <h2 className="self-start leading-tight relative z-10">
                            {subtitle}
                        </h2>
                        <svg
                            width="153"
                            height="80"
                            viewBox="0 0 153 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="absolute w-[153px] h-[78px] left-[-10px] top-[-10px]"
                        >
                            <path
                                d="M2.82687 66.758C17.8653 65.2062 48.7964 62.8268 63.7434 62.9303C100.928 63.1372 121.67 63.1372 149.856 66.6546C115.936 67.9478 55.2632 68.465 21.3428 72.8101C46.5391 71.31 98.884 72.2928 123.806 73.4825C106.724 74.2067 81.9543 73.3273 63.6824 78.1379"
                                stroke="white"
                                strokeWidth="3.57506"
                                strokeDasharray="397.23"
                                strokeDashoffset="397.23"
                                className="animate-draw"
                            ></path>
                        </svg>
                    </div>
                </div>
            </div>
            <motion.div className="ml-5 w-6/12 max-md:ml-0 max-md:w-full"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <p className="text-xl leading-8 text-white max-md:mt-10 max-md:max-w-full text-justify">
                    {description}
                </p>
            </motion.div>
        </header>
    );
};

export default SectionHeading;